"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
class DefaultVideoElementResolutionMonitor {
    constructor() {
        this.observerQueue = new Set();
        this.element = null;
        this.resizeObserver = new ResizeObserver(entries => {
            for (const entry of entries) {
                const { width, height } = entry.contentRect;
                this.notifyObservers(width, height);
            }
        });
    }
    notifyObservers(newWidth, newHeight) {
        for (const observer of this.observerQueue) {
            observer.videoElementResolutionChanged(newWidth, newHeight);
        }
    }
    registerObserver(observer) {
        this.observerQueue.add(observer);
    }
    removeObserver(observer) {
        this.observerQueue.delete(observer);
    }
    bindVideoElement(newElement) {
        if (this.element === newElement) {
            return;
        }
        if (this.element) {
            this.resizeObserver.unobserve(this.element);
        }
        this.element = newElement;
        if (this.element) {
            this.resizeObserver.observe(this.element);
        }
    }
}
exports.default = DefaultVideoElementResolutionMonitor;
//# sourceMappingURL=DefaultVideoElementResolutionMonitor.js.map